import React from "react";
import FeaturesMobile from "./FeaturesMobile";
import FeaturesDesktop from "./FeaturesDesktop";
import useScreenSize from "./hooks/useScreenSize";

const Features = () => {
  const { isLargeScreen } = useScreenSize();
  return <></>;
  return false ? <FeaturesDesktop /> : <FeaturesMobile />;
  //   return <FeaturesMobile />;
};

export default Features;
